module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Arosa_COA-80450f1e0ae913e01d39f60cf1a20f90.svg";